import Badge from '@ilg-totallymoney/ui/components/Badge'

const SameDayDepositBadge = () => (
    <Badge
        icon="poundInCircle"
        text="Money in 24 hours"
        impact="medium"
        size="medium"
    />
)

export default SameDayDepositBadge
